export default "__VITE_ASSET__b459d1db__"